import(/* webpackMode: "eager" */ "/Users/cabhishek/Desktop/Numdle/numdle/app/page.js");
